/**
 * Owl Carousel Slider
 */


export default function HWY_Slider() {

	const selectors = {
		carousel: ".hwy__carousel .owl-carousel",
		mediaCarousel: ".hwy__media .owl-carousel"
	};

	this.init = () => {
		createCarousel();
		createMediaCarousel();
	};

	const createCarousel = () => {
		if (jQuery(selectors.carousel).length) {
			jQuery(selectors.carousel).each(function () {
				const el = jQuery(this);
				const autoScroll = true;
				const margin = el.data("margin") ? el.data("margin") : 0;
				const stage = el.data("stage") ? el.data("stage") : 0;

				el.owlCarousel({
					autoplay: autoScroll,
					autoplayTimeout: 7000,
					dots: true,
					items: 1,
					center: true,
					loop: true,
					margin: margin,
					nav: false,
					smartSpeed: 700,
					stagePadding : stage,
				});
			})
		}
	}

	const createMediaCarousel = () => {
		if (jQuery(selectors.mediaCarousel).length) {
			jQuery(selectors.mediaCarousel).each(function () {
				jQuery(this).owlCarousel({
					autoplay: true,
					autoplayTimeout: 7000,
					autoWith: true,
					center: true,
					dots: true,
					freeDrag: false,
					items: 1,
					loop: true,
					margin: 20,
					mouseDrag: false,
					nav: false,
					pullDrag: false,
					smartSpeed: 700,
					responsive: {
						0: {
							stagePadding: 40,
						},
						768: {
							stagePadding: 250,
						}
					},
					touchDrag: false,
				});
			})
		}
	}

}
